/*  iceberg-ui  */
import { Box, Button, Flex, Icon } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/* Hooks */
import { useIsOnTrialFromPartnerTenantInfo } from 'hooks/dataAccess/Session/isOnTrial';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

/*  Internal  */
import { EmailReportButtonWithModal } from '../EmailReportButtonWithModal';
import { ScheduleReportButtonWithModal } from '../ScheduleReportModal';
import { hasMultipleSections } from '../helpers';

export const HeaderActionsSetupReportOrPrint = ({
    noData,
    openNavigationFlyout,
    openEditFlyout
}: {
    noData?: boolean;
    openNavigationFlyout?: () => void;
    openEditFlyout?: () => void;
}) => {
    const { t } = useTranslation();
    const { reportType } = useParams();
    const isPrintButtonDisabled = useIsOnTrialFromPartnerTenantInfo();
    const showNavigation = hasMultipleSections(reportType);
    const showScheduleReport = reportType !== 'offboard';

    return (
        <Flex
            data-testid="headerActionsSetupReportOrPrint"
            data-trackid="headerActionsSetupReportOrPrint"
            sx={{
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '8px'
            }}
        >
            <DarkTooltip
                arrow
                title={
                    isPrintButtonDisabled
                        ? t('Tooltips.exportFunctionality.disabled')
                        : ''
                }
            >
                <Box data-testid="headerActionsSetupReportOrPrintPrintBtnBox">
                    <Button
                        data-testid="headerActionsSetupReportOrPrintPrintBtn"
                        data-trackid="reports_headerActions_printReport"
                        disabled={isPrintButtonDisabled || noData}
                        onClick={() => window.print()}
                        size="small"
                    >
                        {t('Common.print')}
                    </Button>
                </Box>
            </DarkTooltip>
            {showScheduleReport && <ScheduleReportButtonWithModal />}
            <EmailReportButtonWithModal disabled={noData} />
            {openNavigationFlyout && showNavigation && (
                <DarkTooltip arrow title={t('Reports.navigation')}>
                    <Button
                        data-testid="reports_headerActions_navigation"
                        data-trackid="reports_headerActions_navigation"
                        disabled={noData}
                        onClick={openNavigationFlyout}
                        variant="icon"
                        size="icon"
                        textStyle="greyIcon"
                        sx={{
                            height: '32px',
                            marginLeft: '0px',
                            width: '32px'
                        }}
                    >
                        <Icon src="List" size={FontSizes[2]} />
                    </Button>
                </DarkTooltip>
            )}
            {openEditFlyout && (
                <DarkTooltip arrow title={t('Reports.editReport')}>
                    <Button
                        data-testid="reports_headerActions_editReport"
                        data-trackid="reports_headerActions_editReport"
                        onClick={openEditFlyout}
                        variant="icon"
                        size="icon"
                        textStyle="greyIcon"
                        // Icon button is slightly bigger than the other buttons, so we need to set the height and width to 32px
                        sx={{ height: '32px', width: '32px' }}
                    >
                        <Icon src="Pencil" size={FontSizes[2]} />
                    </Button>
                </DarkTooltip>
            )}
        </Flex>
    );
};
